import { gridProTemplate } from '@genesislcap/grid-pro';
export const zeroGridProTemplate = gridProTemplate;
